import { useEffect, useState } from 'react'

import { getAuctionUserApi } from '../api'

//calculates the maximum amount that that user can purchase
export const calculatePurchaseAmount = (amount, item) => {
  const maxAllowed = calculateMaxPurchaseAmount(item)
  // Clamp between 1 and maxAllowed
  return Math.min(Math.max(amount, 1), maxAllowed);
}

export const calculateMaxPurchaseAmount = (item) => {

  const totalInfinite = item.TotalItemsAvailable == null
  const perPersonInfinite = item.LimitPerPerson == null
  const auctionLeft = totalInfinite ? Infinity : Math.max(0, item.TotalItemsRemaining)
  const personLeft = perPersonInfinite ? Infinity : Math.max(0, item.LimitPerPerson - item.MyAmountPurchased)
  const maxAllowed = Math.min(auctionLeft, personLeft)

  // If nothing can be purchased at all
  if (maxAllowed < 1) return 0

  return maxAllowed
}

export const isUserRegisteredForAuction = (auctionUser, auctionCode) =>
  auctionUser?.MyAuctions?.some((auction) => auction.Auction.AuctionCode === auctionCode)

export const getBrowseItemRoute = (auctionCode, itemCode) => ({
  pathname: '/browse/item',
  search: `?auctionId=${auctionCode}&itemId=${itemCode}`
})

export const getPrivateItemRoute = (auctionCode, itemCode, isFixedItem = false) => ({
  pathname: isFixedItem ? '/auction/fixeditem' : '/auction/item',
  search: `?auctionId=${auctionCode}&${isFixedItem ? 'fixedItemId' : 'itemId'}=${itemCode}`
})

export const useResolvedAuctionUser = (authenticatedUser, auctionUser) => {
  const [hasResolvedAuctionUser, setHasResolvedAuctionUser] = useState(false)

  useEffect(() => {
    let isMounted = true

    if (!authenticatedUser || auctionUser) {
      setHasResolvedAuctionUser(true)
      return () => {
        isMounted = false
      }
    }

    const loadAuctionUser = async () => {
      const user = await getAuctionUserApi()

      if (!isMounted) return

      if (user?.error) {
        console.log('Error loading auction user', user.error)
      }

      setHasResolvedAuctionUser(true)
    }

    loadAuctionUser()

    return () => {
      isMounted = false
    }
  }, [authenticatedUser, auctionUser])

  return hasResolvedAuctionUser
}
